import { Search } from '@mui/icons-material';
import { ReactComponent as CancelIcon } from 'new/components/icons/fi-sr-cross-circle.svg';
import { IconButton } from 'new/elements/IconButton/IconButton';
import { TextField } from 'new/elements/TextField';
import React, { ChangeEvent, MouseEvent, useRef, useState } from 'react';
import classes from './ExpandableSearchBar.module.scss';

interface ExpandableSearchBarProps {
  onChange: (value: string) => void;
}

export const ExpandableSearchBar = ({ onChange }: ExpandableSearchBarProps) => {
  const [value, setValue] = useState<string>('');
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    setValue(newValue);
    onChange(newValue);
  };

  const onClear = () => {
    setValue('');
    onChange('');
    inputRef.current?.focus();
  };

  const onExpand = () => {
    setIsExpanded(true);
  };

  const onBlur = () => {
    if (!value.trim()) {
      setIsExpanded(false);
    }
  };

  return (
    <div className={classes.root}>
      <IconButton data-testid="expandable-search-button" onClick={onExpand}>
        <Search />
      </IconButton>
      {isExpanded && (
        <div className={classes.popUp}>
          <TextField
            inputRef={inputRef}
            value={value}
            autoFocus
            inputProps={{
              ['data-testid']: 'expandable-search-input',
            }}
            InputProps={{
              endAdornment: value.trim() ? (
                <CancelIcon className={classes.clearIcon} onClick={onClear} />
              ) : null,
            }}
            fullWidth
            onBlur={onBlur}
            onChange={onInputChange}
          />
        </div>
      )}
    </div>
  );
};
